import { gatewayApi as api } from './gatewayApi';

// Types
export interface DashboardStats {
  totalParts: number;
  totalPurchaseOrders: number;
  totalWorkOrders: number;
  activeWorkOrders: number;
  completedWorkOrders: number;
  totalUsers: number;
  totalClients: number;
  recentActivity: ActivityItem[];
}

export interface ActivityItem {
  id: string;
  type: 'part_created' | 'work_order_created' | 'user_login' | 'part_approved' | 'part_rejected' | 'purchase_order_created' | 'purchase_order_rejected';
  description: string;
  timestamp: string;
  userId: string;
  userName: string;
}

export interface ChartData {
  labels: string[];
  datasets: {
    label: string;
    data: number[];
    backgroundColor?: string[];
    borderColor?: string[];
  }[];
}

// Dashboard API Service
export const dashboardApi = {
  // Get dashboard statistics
  getStats: (): Promise<DashboardStats> =>
    api.get<DashboardStats>('/dashboard/stats'),

  // Get recent activity
  getRecentActivity: (limit?: number): Promise<ActivityItem[]> =>
    api.get<ActivityItem[]>('/dashboard/activity', { limit }),

  // Get parts chart data
  getPartsChartData: (period: 'daily' | 'weekly' | 'monthly' = 'monthly'): Promise<ChartData> =>
    api.get<ChartData>('/dashboard/charts/parts', { period }),

  // Get work orders chart data
  getWorkOrdersChartData: (period: 'daily' | 'weekly' | 'monthly' = 'monthly'): Promise<ChartData> =>
    api.get<ChartData>('/dashboard/charts/workorders', { period }),

  // Get user activity
  getUserActivity: (userId?: string): Promise<ActivityItem[]> =>
    api.get<ActivityItem[]>('/dashboard/user-activity', { userId }),

  // Get system health
  getSystemHealth: (): Promise<{
    status: 'healthy' | 'warning' | 'error';
    message: string;
    lastCheck: string;
  }> =>
    api.get<{
      status: 'healthy' | 'warning' | 'error';
      message: string;
      lastCheck: string;
    }>('/dashboard/health'),
}; 